import 'core-js/features/promise'
import i18n from 'i18next'

// @ts-ignore
import Polyglot from 'i18next-polyglot'

import { initReactI18next } from 'react-i18next'

import languageDetector from 'aem-libs-react-ts/src/services/LanguageDetector'

import cs from './i18n/cs.json'
import en from './i18n/en.json'

declare var process: any

const resources: i18n.Resource = {
  cs: {
    translation: cs
  },
  en: {
    translation: en
  }
}

i18n
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  .use(Polyglot)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: process.env.NODE_ENV === 'development',
    fallbackLng: 'en',
    lng: languageDetector(),
    resources,

    detection: {
      order: ['htmlTag']
    },

    interpolation: {
      escapeValue: false // not needed for react as it escapes by default
    }
  })

export default i18n
